export default "__VITE_ASSET__bM50Ho77__"